import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Subject, takeUntil, timer } from 'rxjs';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
  selector: 'app-endasure-email',
  templateUrl: './endasure-email.component.html',
  styleUrls: ['./endasure-email.component.scss'],
  standalone: false
})
export class EndasureEmailComponent {
  captchaResolved: boolean = false;
  private readonly destroy$ = new Subject<void>();
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(private readonly endasureService: EndasureService,
    public dialogRef: MatDialogRef<EndasureEmailComponent>,
    private readonly globalmsgService: GlobalMessageService,
    private readonly viewPortScroller: ViewportScroller
  ) { }

  emailForm = new FormGroup({
    FName: new FormControl(null, { validators: Validators.required }),
    LName: new FormControl(null, { validators: Validators.required }),
    emailId: new FormControl(null, { validators: Validators.required }),
    recaptcha: new FormControl(null, [Validators.required]),
  });
  get form() {
    return this.emailForm.controls;
  }
  ngOnInit() {
    this.endasureService.vistInfoData$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        this.emailForm.patchValue({
          FName: data.firstName || null,
          LName: data.lastName || null,
          emailId: data.eMail || null,
        });
      }
    })
    setTimeout(() => { document.querySelector('.cdk-global-overlay-wrapper')?.removeAttribute('popover') }, 0);
  }
  emailResult() {
    if (this.emailForm.valid) {
      this.endasureService.popUpData$.next(this.emailForm.value);
      this.endasureService.postAPI().pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        if (x === 'Success') {

          this.dialogRef.close({
            status: 'Success',
            message: 'common.value_calculator_formSubmit_success'
          });
        }
      });
    }
    else {
      this.emailForm.markAllAsTouched();
    }
  }

  checkCaptcha(captchaResponse: string) {
    this.captchaResolved = !!(captchaResponse && captchaResponse.length > 0);
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
